import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);
Vue.use(router)
Vue.config.productionTip = false
Vue.config.silent = true


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      if (sessionStorage.getItem("username")) {
        next()
      } else {
        alert("登录信息已失效，请重新登录");
          next({
            path: '/',
        })
      }
  } else {
      next()
  }
})










new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
